export default __webpack_public_path__ + "static/media/megane-rs-large.b5c4320f.jpg";